export default __webpack_public_path__ + "static/media/Ad_Bild_1.b882df5b.jpg";